let offer = "offer_1";
$(function() {
    
    if (typeof product_options == 'undefined'){
        console.error('offer configuration missing');
        return false;
    }
    
    //var product_options = {"frequency":{"90":{"flavors":{"black-cherry":19843039363183,"original-apple":19843039395951},"return_to":"cart%2Fadd%3Fid%5B%5D%3D32133309005963%26id%5B%5D%3D20639840895087%26id%5B%5D%3D39281726980235"},"180":{"flavors":{"black-cherry":29389031473263,"original-apple":29389029605487},"return_to":"cart%2Fadd%3Fid%5B%5D%3D32133309005963%26id%5B%5D%3D20639840895087%26id%5B%5D%3D39281726980235"},"30":{"flavors":{"black-cherry":29389025935471,"original-apple":29389027344495},"return_to":"cart%2Fadd%3Fid%5B%5D%3D32133309005963"}}};
    
    // FLAVOR SELECTOR
    var has_flavors = product_options[offer].has_flavors;
    var flavorValue = has_flavors ? 'original-apple' : 'default';
    //var flavorValue = 'black-cherry';
    // FREQUENCY SELECTOR
    var freqValue = typeof product_frequency != 'undefined' && product_frequency == 'sub' ? 'subscribe' : 'one-time';
    var selling_plans = {
        //freq days : selling plan ID (plan, not group)
        30: 514785419,
        60: 514818187,
        90: 514850955,
        120: 514883723,
        150: 551321739,
        180: 514916491
    };

    // grab the recharge selling plans from the offer json if they are present
    var r_selling_plans = {};
    Object.keys(product_options[offer].frequency).map(function (key) {
        if (product_options[offer].frequency[key].selling_plan) {
            r_selling_plans[key] = product_options[offer].frequency[key].selling_plan;
        }
    });
    // replace the selling plans with the recharge selling plans if they existed
    if (!isEmpty(r_selling_plans)) {
        selling_plans = r_selling_plans;
    }

    function update_frequency_value() {
        Object.keys(product_options[offer].frequency).map(function (key) {
            if (product_options[offer].frequency[key].selling_plan) {
                r_selling_plans[key] = product_options[offer].frequency[key].selling_plan;
            }
        });
    }
  
    function update_flavor_value() {
        has_flavors = product_options[offer].has_flavors;
        flavorValue = has_flavors ? $('select.flavor-select').val() : 'default';
    }

    var primary_product =   (freq = 90) => product_options[offer].frequency[freq].flavors[flavorValue];
    var return_to =         (freq = 90) => product_options[offer].frequency[freq].return_to;
    var frequency =         (freq = 90) => freqValue === 'subscribe' ? `&properties[_frequency]=${freq}&selling_plan=${selling_plans[freq]}&properties[_product_origin]=landing_page` : '&properties[_product_origin]=landing_page';
    // var product_origin =    "&properties%5B_product_origin%5D%3Dlanding_page"
    
    // DEFAULT CTA href VALUES
    Object.keys(product_options[offer].frequency).map(function (key) {
        $(`.freq${key}-link`).attr('href', `https://humann.com/cart/add?id[]=${primary_product(key)}${frequency(key)}&return_to=${return_to(key)}`);
    });

    $(document).on('change','select.flavor-select',function(){
        $('select.flavor-select').val(this.value);
        flavorValue = this.value;
        update_offer_urls();
    });

    if (freqValue == 'one-time') {
        $('.special-offer-sub-text').addClass('hide-deliver-text');
        $('.sub-price').hide();
        $('.otp-price').show();
    }

    // PURCHASE FREQUENCY SELCTOR
    $('.option-one-time').click(function freqOne() {
        $('.option-one-time').prop('checked',true);
        $('.sub-price').hide();
        $('.otp-price').show();
        // $('.title-price.active-price.otp-price, span.per-canister.active-price.otp-price, span.cta-label.active-price.otp-price').addClass('show-price');
        // $('.title-price.active-price.sub-price, span.per-canister.active-price.sub-price, span.cta-label.active-price.sub-price').removeClass('show-price');
        // DELIVERY EVERY X AMOUNT OF DAYS
        $('.special-offer-sub-text').addClass('hide-deliver-text');
        freqValue = 'one-time';
        update_offer_urls();
    })
    $('.option-subscription').click(function freqSub() {
        $('.option-subscription').prop('checked',true);
        $('.sub-price').show();
        $('.otp-price').hide();
        // $('.title-price.active-price.sub-price, span.per-canister.active-price.sub-price, span.cta-label.active-price.sub-price').addClass('show-price');
        // $('.title-price.active-price.otp-price, span.per-canister.active-price.otp-price, span.cta-label.active-price.otp-price').removeClass('show-price');
        
        // DELIVERY EVERY X AMOUNT OF DAYS
        $('.special-offer-sub-text').removeClass('hide-deliver-text');
        freqValue = 'subscribe';
        update_offer_urls();
    })
    function update_offer_urls() {
        Object.keys(product_options[offer].frequency).map(function (key) {
            $(`.freq${key}-link`).attr('href', `https://humann.com/cart/add?id[]=${primary_product(key)}${frequency(key)}&return_to=${return_to(key)}`);
        });
    }
    
    $(document).on('click','.product-options .option', function(){
        $('.product-options .option').removeClass('selected');
        $(this).addClass('selected');
        $('.offer_cards').hide();
        
        offer = $(this).data('option');
        $('#' + offer).show();
        update_flavor_value();
        update_frequency_value();
        update_offer_urls();
    });

    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }
        return true;
    }

});